import { IGerarTokenFiservResponse, IKioskRepository } from "../../../domains/kiosk/interfaces/repositories/IKioskRepository";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { ILocalStorageRepository } from "../../interfaces/ILocalStorageRepository";
import { IConfigRepository } from "../../interfaces/IConfigRepository";
import { ConfigTotemMeep, configTotemMeepToKiosk } from "./ConfigTotemMeep";
import { Kiosk } from "../../../domains/kiosk/aggregates/Kiosk";
import { HttpRepository } from "./_HttpRepository";
import { LocalStorageRepository } from "../localStorage/_LocalStorageRepository";
import { CefSharpConfigRepository } from "../../services/cefSharpService/local/CefSharpConfigRepository";
import enviroment from "corss-cutting/enviroment";
import { ReactNativeConfigRepository } from "Infrastructure/services/reactNativeServices/ReactNativeConfigService";
import { isReactNative } from "utils/constants";

const keyStorage = "@kiosk";
export const keyBlockedCards = "@blockedCards";

export const KioskRepository = (
): IKioskRepository => {

  const httpRepository: IHttpRepository = HttpRepository();
  const localStorageRepository: ILocalStorageRepository = LocalStorageRepository();

  let configRepository: IConfigRepository;
  if(isReactNative) {
    configRepository = ReactNativeConfigRepository();
  } else {
    configRepository = CefSharpConfigRepository();
  }
  const config: IConfigRepository = configRepository;

  const syncAsync = async () => {
    const configs = await config.getConfigAsync()
    const reponseConfigMeep = await httpRepository.postAsync<any, ConfigTotemMeep>
      ("/UsuarioMeepPOS/AtualizarDadosEquipamento",
        {
          IMEI: configs.macAddress,
          // IMEI: '00215D299378',
          UsuarioMeepPOSId: configs.equipamentId,
          VersaoReactTotem: enviroment.appVersion
        }
      )
    localStorageRepository.post(keyStorage, configTotemMeepToKiosk(reponseConfigMeep));
    httpRepository.getAsync<string[]>(`/Cartoes/Bloqueados?localId=${reponseConfigMeep.localId}`)
      .then((tags) => localStorageRepository.post(keyBlockedCards, tags))
      .catch(() => {});
    console.log("sync configKiosk", configs);
    return {
      ...configTotemMeepToKiosk(reponseConfigMeep),
      token: configs.token,
    };
  };


  const getAsync = async (): Promise<Kiosk | null> => {
    let kioskValues: Kiosk | null = await localStorageRepository.get<Kiosk>(
      keyStorage
    );
    return kioskValues ?? null;
  };



  const gerarTokenFiservAsync = async (): Promise<IGerarTokenFiservResponse> => {
    const response = await httpRepository.postAsync<undefined, IGerarTokenFiservResponse>(
      "UsuarioMeepPOS/GerarTokenFiserv",
      undefined
    );
    return response;
  };

  return { getAsync, syncAsync, gerarTokenFiservAsync };
};

